export default "__VITE_ASSET__CSbTOo1G__"